import { useEffect, useRef, useState } from "react";

/** Reveal-on-scroll hook using IntersectionObserver. */
export default function useReveal(options = {}) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -50px 0px", ...options }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [options]);

    return [ref, visible];
}
